import CloseIcon from "@mui/icons-material/Close"
import { Button, DialogTitle, IconButton } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import {  useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import CustomTextField from "../CustomTextField"
import { useSelector } from "react-redux"

const ModalCancelarVacaciones = ({ open, handleClose, vacacion, onSubmit }) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const loadCancelarVacacionSelector = useSelector((store) => store.vacaciones.loadCancelarVacacion)

  const defaultValues = {
    id: null,
    name: null,
    diasSolicitados: null,
  }

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    reset(vacacion)
  }, [vacacion, reset])

  const cancelarVacaciones = (datos) =>{
    onSubmit(datos)
  }

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} type="text" readOnly={true} name="name" label="Licencia" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} type="text" readOnly={true} name="diasSolicitados" label="Dias solicitados" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadCancelarVacacionSelector === "LOADING"}
                onClick={handleSubmit(cancelarVacaciones)}
              >
                Cancelar licencia
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalCancelarVacaciones
